import { Box, Button, Card, CircularProgress, Dialog, DialogActions, DialogContentText, DialogTitle, Divider, Grid, SwipeableDrawer, Typography } from "@mui/material"
import React from "react"
import HomeState from "../../../../State/HomeState"
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import PaymentIcon from '@mui/icons-material/Payment';
import ProfileDispatch from "./model";
class Profile extends React.PureComponent<{}>{

    render() {
        let state: HomeState = (this.props as any).state
        let dispatcher: ProfileDispatch = (this.props as any).dispatcher

        let html: JSX.Element

        if (state.loading) {
            html = <Box sx={{ height: '100%', flexDirection: 'column' }} display="flex"
                justifyContent="center"
                alignItems="center">
                <CircularProgress />
                <Typography variant="subtitle1" sx={{ mr: 1, ml: 1 }}>
                    در حال دریافت اطلاعات
                </Typography>
            </Box>
        } else {
            if (state.user) {

                html = <Box sx={{ height: '100%', flexDirection: 'column', mt: 5 }} display="flex"
                    alignItems="center">
                    <Box
                        component="img"
                        sx={{
                            height: '120px',
                            width: '120px',
                            borderRadius: '60px'
                        }}
                        alt='profile pic'
                        src={state.user.pic}
                        crossOrigin="anonymous"
                    />
                    <Divider orientation="horizontal" variant="middle" flexItem sx={{ mt: 3 }} />

                    <Typography fontWeight='fontWeightBold' variant="h6" display="block" gutterBottom sx={{ mr: 1, ml: 1, mt: 3 }}>
                        {state.user.name}
                    </Typography>
                    <Typography variant="subtitle1" display="block" gutterBottom sx={{ mr: 1, ml: 1 }}>
                        {state.user.phone}
                    </Typography>

                    <Typography variant="subtitle1" display="block" gutterBottom sx={{ mr: 1, ml: 1 }}>
                        املاک {state.user.realEstateName}
                    </Typography>
                    <Typography variant="subtitle1" display="block" gutterBottom sx={{ mr: 1, ml: 1 }}>
                        {state.user.activity}
                    </Typography>

                    <Typography variant="subtitle1" display="block" gutterBottom sx={{ mr: 1, ml: 1 }} textAlign='center'>
                        عضویت از تاریخ <br />{new Date(state.user.registerDate).toLocaleDateString('fa-IR')}
                    </Typography>

                    <Typography variant="subtitle1" display="block" gutterBottom sx={{ mr: 1, ml: 1 }} textAlign='center'>
                        اشتراک تا تاریخ <br />{new Date(state.user.expireDate).toLocaleDateString('fa-IR')}
                    </Typography>
                    <Typography variant="subtitle1" display="block" gutterBottom sx={{ mr: 1, ml: 1 }} textAlign='center'>
                        موجودی کیف پول <br /> {state.user.wallet.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} تومان
                    </Typography>

                    <Box sx={{ flexGrow: 1 }} />

                    <Box sx={{ flexDirection: "column", display: 'flex' }}>

                        <Button variant="contained" startIcon={<ShoppingBasketIcon sx={{ ml: 1 }} />} color="primary" size='small' onClick={() => {
                            dispatcher.profile(false)
                            dispatcher.main()
                        }}>
                            صفحه اصلی
                        </Button>

                        <Button variant="contained"  sx={{ mt: 0.25 }} startIcon={<ShoppingBasketIcon sx={{ ml: 1 }} />} color="secondary" size='small' onClick={() => {
                            dispatcher.profile(false)
                            dispatcher.orders()
                        }}>
                            سفارشات من
                        </Button>


                        <Button variant="contained" sx={{ mt: 0.25 }} startIcon={<PaymentIcon sx={{ ml: 1 }} />} color="warning" size='small' onClick={() => {
                            dispatcher.profile(false)
                            dispatcher.payments()
                        }}>
                            تاریخچه پرداخت
                        </Button>

                    </Box>

                </Box>
            } else {
                //....
                html =  <Dialog
                open={true}
                dir="rtl"
                scroll='paper'>

                <DialogTitle textAlign='center'>
                    خدمات فایل چرخ
                </DialogTitle>

                    
                <DialogContentText sx={{p : 2}}  textAlign='center'>
                    برای دریافت خدمات فایل چرخ فقط از طریق اپلیکیشن فایل چرخ اقدام به ورود نمایید.
                </DialogContentText>

                <DialogActions>
                    <Button href="https://filecharkh.com">دانلود اپلیکیشن</Button>
                </DialogActions>

            </Dialog>
            }

        }

        return (
            <SwipeableDrawer
                dir="ltr"
                anchor='right'
                open={state.profile}
                SlideProps={{ direction: 'left' }}

                onClose={() => {
                    dispatcher.profile(false)
                }}
                onOpen={() => {
                    dispatcher.profile(true)

                }}
                PaperProps={{
                    sx: {
                        width: '80%'
                    },
                }}>
                <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
                    <Box sx={{ flexDirection: 'row' }} display="flex"
                        justifyContent="center"
                        alignItems="center">
                        <Typography fontWeight='fontWeightBold' variant="h6" display="block" gutterBottom sx={{ mr: 1, ml: 1 }} color='primary'>
                            پروفایل کاربری
                        </Typography>
                    </Box>

                    <Divider orientation="horizontal" variant="middle" flexItem sx={{ mt: 1 }} />
                    <Box sx={{ height: '100%', width: '100%', flexDirection: 'column', mt: 2 }} display="contents"
                        justifyContent="center"
                        alignItems="center">
                        <Card variant="elevation" sx={{ height: '100%', borderRadius: '12px', borderColor: 'transparent', p: 2, mr: 1, ml: 1, mt: 1 }} >
                            <Box sx={{ flexDirection: 'column', height: '100%' }} display="flex">

                                {html}
                            </Box>
                        </Card>
                    </Box>
                </Box>
            </SwipeableDrawer>


        )
    }
}

export default Profile